import Vue from 'vue'
import VueRouter from 'vue-router'


import home from '../views/home.vue'
import terms from '../views/terms.vue'
import privacy from '../views/privacy.vue'
import about from '../views/about.vue'
import contact from '../views/contact.vue'
import community from '../views/community.vue'
import virtual from '../views/virtual.vue'
import device from '../views/device.vue'
import information from '../views/information.vue'
import account from '../views/account.vue'
import mobile from '../views/mobile.vue'

Vue.use(VueRouter)

const routes = [
    {
        path: '/',
        redirect: '/home' // 将根路径重定向到 /home
    },
    { 
        path: '/home',
        name: 'home',
        component: home,
     
    },
    { 
        path: '/mobile',
        name: 'mobile',
        component: mobile,
       
    },

    {
        path: '/terms',
        name: 'terms',
        component: terms,
        meta: { title: '1' },
    },
    {
        path: '/privacy',
        name: 'privacy',
        component: privacy,
        meta: { title: '1' },
    },
    {
        path: '/about',
        name: 'about',
        component: about
    },
    {
        path: '/contact',
        name: 'contact',
        component: contact
    },
    {
        path: '/community',
        name: 'community',
        component: community
    },
    {
        path: '/virtual',
        name: 'virtual',
        component: virtual
    },
    {
        path: '/device',
        name: 'device',
        component: device
    },
    {
        path: '/information',
        name: 'information',
        component: information
    },
    {
        path: '/account',
        name: 'account',
        component: account
    },

]

const router = new VueRouter({
    routes
})
router.beforeEach((to, from, next) => {
    if (to.meta.title) {
        document.title = "\u2063"; // 零宽空格（Zero Width Space）
    }
    next();
  });

export default router
